exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carihesapsearch[data-v-2bca5e51]{max-height:32;width:95%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:justify;border-bottom:1px solid #767676}.teksatir[data-v-2bca5e51]{display:contents}", ""]);

// exports
